export default function () {
  /* 表格列头 */
  return [
    { label: "", type: "selection", width: 55 },
    { label: "序号", type: "index", width: 80 },
    // { label: "店铺名称", prop: "store_id", width: 200, slots: "store_id" },
    { label: "卡券类型", prop: "exchange_type", width: 100, slots: "exchange_type" },
    { label: "卡号", prop: "cardNumber", width: 100 },
    { label: "卡密", prop: "password", width: 100 },
    { label: "卡券名称", prop: "couponTitle", width: 200 },
    { label: "卡券描述", prop: "msg", width: 200 },
    { label: "金额", prop: "price", width: 100 },
    { label: "使用门槛", prop: "maxPrice", width: 100 },
    { label: "状态", prop: "cardStatus", slots: "cardStatus" },
    {
      label: "兑换人手机号", prop: "userPhone", width: 120,
      slots: "userPhone",
    },
    {
      label: "兑换时间",
      prop: "exchangeTime",
      width: 180,
      slots: "exchangeTime",
    },
    {
      label: "核销时间",
      prop: "writeOffTime",
      width: 180,
      slots: "writeOffTime",
    },
    {
      label: "创建时间",
      prop: "createTime",
      width: 180,
    },
    // { label: "核销人", prop: "receiveUser", width: 120 },
    {
      label: "操作",
      prop: "operation",
      width: 50,
      slots: "operation",
      fixed: "right",
    },
  ];
}
